import { ChangeDetectorRef, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { AppliedBranchDetails } from '../apply-asset-request/apply-asset-request.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { ALERT_TYPE } from 'src/app/constants';
import { Company } from 'src/model/company.model';

@Component({
  selector: 'app-asset-shared-branch-list',
  standalone: false,
  templateUrl: './asset-shared-branch-list.component.html',
  styleUrl: './asset-shared-branch-list.component.scss',
})
export class AssetSharedBranchListComponent {
  @Input() branchDistributionList: AppliedBranchDetails[] = new Array;
  @Input() totalBranchAmount = 0;
  @Input() allowAdding = false;
  // @Output() distributedList = new EventEmitter<any>();

  protected sharedService = inject(SharedService)
  protected cdr = inject(ChangeDetectorRef);

 

  getSelectedCompany(company: Company) {
    if (this.branchDistributionList.length > 0 && this.branchDistributionList.find((item) => item.appliedBranch.ID == company.ID)) {
      this.sharedService.openAlert("This branch existed in list, please check properly!", ALERT_TYPE.DANGER);

    }
    else {
      this.branchDistributionList.push({ appliedBranch: company, amount: 0 });
      this.cdr.detectChanges();
    }
  }

  removeBranch(index: number) {
    this.branchDistributionList.splice(index, 1);
  }

}
